// ** React Imports
import { Fragment } from "react";
import { useSelector } from "react-redux";

// ** Custom Components
import NavbarUser from "./components/NavbarUser";
// import NavbarBookmarks from './NavbarBookmarks'

const ThemeNavbar = (props) => {
  // ** Props
  // const { skin, setSkin, setMenuVisibility } = props
  const layoutStore = useSelector((state) => state.layout);

  const { skin, setSkin } = props;

  return (
    <Fragment>
      {/* <div className='bookmark-wrapper d-flex align-items-center'>
        <NavbarBookmarks setMenuVisibility={setMenuVisibility} />
      </div> */}
      <div className={`navbar-time ${layoutStore.menuHidden ? "ms-1" : ""}`}>
        <span className="text-dark">
          {new Intl.DateTimeFormat("en-US", {
            weekday: "short",
            // year: "2-digit",
            month: "long",
            day: "2-digit",
          }).format(new Date())}
        </span>
      </div>
      <NavbarUser skin={skin} setSkin={setSkin} />
    </Fragment>
  );
};

export default ThemeNavbar;
